import { isDevMode } from '@angular/core';

//TODO: Just for testing purposes, this will be removed.
export function showDevWarning(msg: string, metadata?: unknown): void {
  if (!isDevMode()) return;
  console.warn('----- Only visible in development mode -----');
  console.warn(
    '%c' + msg,
    'color: #000; background: #ff0055; font-size: 14px; font-weight: bold; padding: 4px;'
  );
  if (metadata) {
    console.warn('Additional info:', metadata);
  }
}
